import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box, Checkbox, Label } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './DealerProductLInesSelector.style';
import { DealersListContext } from '../DealersListContext';
import { productLineLabelMap } from '../../utils/constants';

const Container = themeStyles.apply(Box, 'Container');
const CheckboxContainer = themeStyles.apply(Box, 'CheckboxContainer');
const CheckboxLabel = themeStyles.apply(Label, 'CheckboxLabel');

const DealerProductLinesSelector = ({ productLines }) => {
  const { t } = useTranslation();
  const { setProductLinesSelection } = useContext(DealersListContext);

  const handleChange = (value, productLine) => {
    if (!productLine) return;
    const update = {};
    update[productLine] = value;
    setProductLinesSelection(prev => ({
      ...prev,
      ...update,
    }));
  };

  return (
    <Container data-testid="cy-productLines-selection">
      {productLines.map(productLine => (
        <CheckboxContainer key={productLine}>
          <Checkbox
            name={productLine}
            value={productLine}
            checked={false}
            onChange={value => handleChange(value, productLine)}
            id={productLine}
          />
          <CheckboxLabel
            htmlFor={productLine}
            size="extraSmall"
            data-testid={`cy-checkbox-${t(`Sub-apps.Dealers.${productLineLabelMap.get(productLine)}`)}`}
          >
            {t(`Sub-apps.Dealers.${productLineLabelMap.get(productLine)}`)}
          </CheckboxLabel>
        </CheckboxContainer>
      ))}
    </Container>
  );
};

DealerProductLinesSelector.propTypes = {
  productLines: PropTypes.arrayOf(PropTypes.string),
};

DealerProductLinesSelector.defaultProps = {
  productLines: [],
};

export default DealerProductLinesSelector;
